export default __webpack_public_path__ + "static/media/school_design_1.a2f2902a.png";